import React, { useLayoutEffect, useState } from "react";

import { useGetExerciseEntrypointQuery } from "../../api/exercise-entrypoint";

function InputAdvice() {
  const { data } = useGetExerciseEntrypointQuery({
    exerciseId: 0,
  });

  const [adviceText, setAdviceText] = useState<string>("&nbsp;");

  useLayoutEffect(() => {
    if (!data) return;
    const {
      user: { layoutLeftHand, layoutRightHand },
      exercise: { lessonAdvice },
    } = data;

    const layoutLeftHandMarkup = layoutLeftHand
      .split("")
      .map((letter: string) => `<span class='key-char'>${letter}</span>`)
      .join("");

    const layoutRightHandMarkup = layoutRightHand
      .split("")
      .map((letter: string) => `<span class='key-char'>${letter}</span>`)
      .join("");

    const text = lessonAdvice
      .replace(
        "%s",
        `<span class="inline-block">${layoutLeftHandMarkup}</span>`,
      )
      .replace(
        "%s",
        `<span class="inline-block">${layoutRightHandMarkup}</span>`,
      );
    setAdviceText(text);
  }, [data]);

  return (
    <div className='mx-auto w-[655px] animate-slow-opacity-show pb-3 pt-[9px] text-center md:pb-4'>
      <p
        className='m-0 hidden md:block'
        dangerouslySetInnerHTML={{ __html: adviceText }}
      />
    </div>
  );
}

export default InputAdvice;
